export default "__VITE_ASSET__DJOMNFw2__"